import React from 'react';
import { Button, Heading, FormGroup } from 'arag-ui-lib';
import _ from 'lodash';
import { FORM_GROUP_VARIANTS } from '../helpers/formGroupVariants';
import { HEADING_2, TERTIARY } from '../helpers/constants';
import CONTENT_STRINGS from '../helpers/contentStrings';

const PreviousApplicationUpdate = (props) => {

    const { PreviousUpdate, Date, answers } = props;

    return (
       <div className={'row print'}>
           <div className="col-sm-12">
               <div className="row col-sm-12">
                    <Heading variant={HEADING_2} title={`${CONTENT_STRINGS.POLICY_UPDATE} ${Date}`} headingTestId={'policy-previous-update-header'}/>
               </div>
               <form className="form-horizontal">
                {
                    _.sortBy(PreviousUpdate.policyUpdateAnswersDtos, ['sortOrder']).map((item, index) => {
                        return (
                            <div key={index}>
                                <FormGroup 
                                    labelSize={'col-sm-5'}
                                    inputSize={'col-sm-7'}
                                    label={item.questionName}
                                    variant={item.inputType}
                                    inputProps={{
                                        name: item.questionMachineName,
                                        label: answers[item.questionMachineName],
                                    }}
                                    formGroupTestId={`policy-previous-update-${item.questionMachineName}`}
                                />
                            </div>
                        )
                    })
                }
                {
                    PreviousUpdate.attachments && PreviousUpdate.attachments.length > 0
                    ?
                        PreviousUpdate.attachments.map((att, index) => (
                            <FormGroup
                                key={index}
                                labelSize={'col-sm-5'}
                                inputSize={'col-sm-7'}
                                label={index === 0 ? CONTENT_STRINGS.ATTACHMENT : ''}
                                variant={FORM_GROUP_VARIANTS.PLAIN}
                                inputProps={{
                                    name: `attachment-${index}`,
                                    label: att.name + (att.tags ? ' - ' + att.tags : '')
                                }}
                                formGroupTestId={`policy-previous-update-attachment-${index}`}
                            />
                        ))
                    :
                        null
                }
                </form>
                <Button
                    onClick={window.print}
                    variant={TERTIARY}
                    label={CONTENT_STRINGS.PRINT}
                    buttonTestId={'policy-previous-update-print'}
                />
           </div>
       </div>
    )
};

export default PreviousApplicationUpdate;